import React, { useRef, useState } from 'react';

import styles from './ContactForm.module.sass';

const FORM_URI =
  'https://api.cake-mag.com/wp-json/contact-form-7/v1/contact-forms/35125/feedback';

const ContactForm = () => {
  const formRef = useRef();
  const [status, setStatus] = useState();

  const handleOnSubmit = async (e) => {
    e.preventDefault();
    const body = new FormData(e.target);

    const data = await fetch(FORM_URI, {
      body,
      method: 'POST',
    });

    setStatus(data.ok ? 'success' : 'error');

    if (data.ok) {
      formRef.current.reset();
    }
  };

  return (
    <div className={styles.wrapper}>
      <p>
        Get in touch with us through the contact form below or send an e-mail to{' '}
        <a href="mailto:hello@cake-mag.com">hello@cake-mag.com</a>
      </p>
      <form
        className={styles.form}
        method="post"
        onSubmit={handleOnSubmit}
        ref={formRef}
      >
        <label>
          <span>Your name</span>
          <input
            aria-invalid="false"
            aria-required="true"
            name="from-name"
            required
            size="40"
            type="text"
          />
        </label>
        <label>
          <span>Your email</span>
          <input
            aria-invalid="false"
            aria-required="true"
            name="email"
            required
            size="40"
            type="email"
          />
        </label>
        <label>
          <span>Subject</span>
          <select name="subject" aria-required="true" aria-invalid="false">
            <option value="Submissions">Submissions</option>
            <option value="Suggestions/Feedback">Suggestions/Feedback</option>
            <option value="Report a bug">Report a bug</option>
            <option value="Other">Other</option>
          </select>
        </label>
        <label>
          <span>Your message</span>
          <textarea
            name="message"
            cols="40"
            required
            rows="10"
            aria-invalid="false"
          ></textarea>
        </label>
        <p>
          <button type="submit">Send</button>
        </p>

        {status === 'error' && <p>An error occurred, try again later.</p>}
        {status === 'success' && (
          <p>Your message has been successfully sent!</p>
        )}
      </form>
    </div>
  );
};

export default ContactForm;
